module.exports = __webpack_public_path__ + "img/left-bg.2105ff8c.png";